export default __webpack_public_path__ + "static/media/TraceparentLogo_grande.bfff1e83.png";